import Vue from 'vue'
import httpManager from '../../util/common'
import EmailPushItem from '../components/EmailPushItem.vue'

Vue.config.productionTip = false

let email_push = {
  name: 'email-push',
  components: {
    EmailPushItem
  },
  data: () => {
    return {
      productList: ['ESGevent'],
      checkedData: {}
    }
  },
  beforeCreate() {
    httpManager("get_email_push", null, null, null, null)
      .then(response => {
        if(response.data.data){
          this.checkedData = response.data.data
        }
      })
      .catch(error => {
      })
  },
  mounted () {
    
  },
  methods: {
  },
  computed: {
    esg_event_type_list() {
      return [
        {'label': this.$t('event.environmental_penalty'),'value':'EnvPunishment'},
        {'label': this.$t('event.environmental_impact_assessment'), 'value': 'EnvImpactAssessment'},
        {'label': this.$t('event.financial_supervision_punishment'),'value':'BankInsurancePunishment'},
        {'label': this.$t('event.work_safety_accident'),'value':'WorkSafetyIncident'},
        {'label': this.$t('event.work_safety_penalty'),'value':'WorkSafetyPunishment'},
        {'label': this.$t('event.product_sampling'), 'value': 'ProductInspection'},
        {'label': this.$t('event.product_recal'),'value':'ProductRecall'},
        {'label': this.$t('event.market_supervision_penalty'), 'value': 'MarketPunishment'},
        {'label': this.$t('event.flight_check'), 'value': 'UnannouncedInspection'},
        {'label': this.$t('event.anticorruption'), 'value': 'AntiCorruption'},
        {'label': this.$t('event.supply_chain'), 'value': 'Announcement'},
        {'label': this.$t('event.security_punishment'), 'value': 'SecurityPunishment'},
        {'label': this.$t('event.security_regulatory'), 'value': 'SecurityRegulatory'},
        {'label': this.$t('event.exchange_regulatory'), 'value': 'ExchangeRegulatory'},
        {'label': this.$t('event.fmi_regulatory'), 'value': 'FinancialMarketInstitutionRegulatory'},
        {'label': this.$t('event.natural_resource_punishment'), 'value': 'NaturalResourcePunishment'},
        {'label': this.$t('event.taxation_punishment'), 'value': 'TaxationPunishment'},
      ]
    },
  }
}
export default email_push


// WEBPACK FOOTER //
// ./src/user_center/js/email_push.js